/**
 * Параметр показывающий зашел ли пользователь в мобильную версию
 */
export const isMobile = window.app && window.app.isMobile
